export default "__VITE_ASSET__CKg76i61__"